<div class="list">
  <ng-content></ng-content>
</div>
